import { useQuery } from "@apollo/client";
import { DateTime } from "luxon";
import { useMemo } from "react";

import {
    GetAssetIntensityQuery,
    GetAssetIntensityQueryVariables,
} from "graphql-types/graphql";

import { GET_ASSET_INTENSITY } from "./use-asset-intensity.query";

export const useAssetIntensityQuery = (assetId: string, year?: number) => {
    const { from, to } = useMemo(() => {
        if (!year) {
            const lastMonth = DateTime.now().minus({ months: 1 });
            const start = lastMonth.minus({ months: 12 });

            return {
                from: start.startOf("month").toISO(),
                to: lastMonth.endOf("month").toISO(),
            };
        }

        return { from: year.toString(), to: `${year}-12-31T23:59:59Z` };
    }, [year]);

    const { data, loading } = useQuery<
        GetAssetIntensityQuery,
        GetAssetIntensityQueryVariables
    >(GET_ASSET_INTENSITY, {
        variables: {
            assetId,
            from,
            to,
        },
    });

    return {
        data: data?.getIntensity,
        loading,
    };
};
